import { LockFilled, MailFilled } from "@ant-design/icons";
import { Alert, Divider, Form, Input, Typography } from "antd";
import { FunctionComponent, useMemo } from "react";
import { Link } from "react-router-dom";
import ActionBtn from "./action-btn";
import { LoginData } from "./login-data";

interface LoginFormProps {
  registrationRoute?: string;
  forgotPasswordRoute?: string;
  serverMsg?: string;
  serverMsgType?: "error" | "success";
  busy?: boolean;
  onSubmit: (data: LoginData) => void;
}

const LoginForm: FunctionComponent<LoginFormProps> = ({
  registrationRoute,
  forgotPasswordRoute,
  onSubmit,
  serverMsg,
  serverMsgType,
  busy,
}) => {
  const RegistrationLink = useMemo(() => {
    if (registrationRoute?.startsWith("http")) {
      return (
        <a href={registrationRoute} target="_blank">
          Register Now
        </a>
      );
    }
    return <Link to={{ pathname: registrationRoute }}>Register Now</Link>;
  }, [registrationRoute]);

  const ForgotPasswordLink = useMemo(() => {
    if (registrationRoute?.startsWith("http")) {
      return (
        <a className="float-right" target={"_blank"} href={forgotPasswordRoute}>
          Forgot Password
        </a>
      );
    }
    return (
      <Link className="float-right" to={{ pathname: forgotPasswordRoute }}>
        Forgot Password
      </Link>
    );
  }, [forgotPasswordRoute]);
  return (
    <Form onFinish={onSubmit} className="public-form">
      <Typography.Title level={4} className="title">
        Login
      </Typography.Title>
      {serverMsg && (
        <Alert
          type={serverMsgType}
          message={serverMsg}
          style={{ marginBottom: 10 }}
        />
      )}
      <Form.Item
        name="email"
        rules={[
          { required: true, type: "email", message: "Email is required!" },
        ]}
      >
        <Input
          type={"email"}
          suffix={<MailFilled />}
          placeholder="Your organization email!"
        />
      </Form.Item>
      <Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, min: 6, message: "Password is required!" }]}
          noStyle
        >
          <Input
            suffix={<LockFilled />}
            type="password"
            placeholder="Your password"
          />
        </Form.Item>
        {ForgotPasswordLink}
      </Form.Item>
      <Form.Item>
        <ActionBtn
          busy={busy}
          type="primary"
          htmlType="submit"
          className="button"
        >
          Login
        </ActionBtn>
      </Form.Item>
      <Divider orientation="center">Or</Divider>
      <div className="tc">{RegistrationLink}</div>
    </Form>
  );
};

export default LoginForm;
